module.exports = __webpack_public_path__ + "img/Boss-6.770ce916.png";